import React, { useState, useEffect } from 'react';

import { ContentBox } from "../../ContentBox"
import { SystemPromptInput } from '../../../Res/SystemPrompt';
import { EnableBadge, AddButton, Space, DisableBadge, SingleLink } from '../../../Res/BaseButton';
import 'rc-datepicker/lib/style.css';
import moment from 'moment';
import { ManagementPrompt } from '../../../Res/ManagementPrompt';
import { setVal2Token, getval2Token } from '../../../../Login/Auth';

import { SELECT_VAL_TYPE_INT, SELECT_VAL_TYPE_STRING } from '../../../Res/BaseInput';
import { BaseSearchBox } from '../../../Res/BaseSearch';
import { SearchInput, SearchSelect } from '../../../../../item/ItemSearch';
import { api_getPlayerList } from '../../../../../api/MyStat/apiPlayer';
import { TableListTitle, setTD, setTDLink, ListBox, setTDFirst } from '../../../../../item/ItemTableList';
import { get_player_position_string, get_player_throw_bat_string, ReqPlayerList } from '../../../../../item/MyStat/ItemPlayer';
import { ACTIVATION_ENABLE, search_activation_attr, get_activation_string, get_activation_color } from '../../../../../item/MyStat/ItemMyStatBase';
import { api_getTeamList } from '../../../../../api/MyStat/apiTeam';
import { ReqTeamList } from '../../../../../item/MyStat/ItemTeam';

export function PlayerList({ id, setIsLoading }) {
    const [tokenId, setTokenId] = useState("")

    const [searchItems, setSearchItems] = useState([])

    const [playerList, setPlayerList] = useState([])
    const [page, setPage] = useState(1)
    const [limit] = useState(30)
    const [count, setCount] = useState(0)
    const [enableCount, setEnableCount] = useState(0)
    const [disableCount, setDisableCount] = useState(0)

    const [team_attr, set_team_attr] = useState([])

    // const [mReqPlayerList, setReqPlayerList] = useState({})

    const [list_obj, set_list_obj] = useState({})

    const [player_name, set_player_name] = useState('')
    const [team_id, set_team_id] = useState('')

    const [searchItem, set_searchItem] = useState()

    useEffect(() => {
        var searchItems = [
            [
                new SearchInput({
                    key: 'player_name',
                    val: player_name,
                    defaultVal: '',
                    title: '以中文名稱搜尋',
                    col: 4
                }),
                new SearchSelect({
                    key: 'team_id',
                    val: team_id,
                    defaultVal: "",
                    valType: SELECT_VAL_TYPE_STRING,
                    title: '所屬球隊',
                    col: 4,
                    attr: team_attr,
                    n:'team_name',
                    v:'team_id',
                    hasBlank: true,
                    blankOption:'全部'
                }),
                new SearchSelect({
                    key: 'player_activation',
                    val: ACTIVATION_ENABLE,
                    defaultVal: ACTIVATION_ENABLE,
                    valType: SELECT_VAL_TYPE_INT,
                    title: '狀態',
                    col: 4,
                    attr: search_activation_attr
                })
            ],
            // new SearchBrLine()
        ]
        setSearchItems(searchItems)
    }, [team_attr])

    useEffect(() => {
        if (id !== undefined && id !== tokenId) {
            var url = getval2Token("url", id)
            // console.log(url)
            setTokenId(id)
            getTeamList()
            var start = (url.page - 1) * limit;
            var mReqPlayerList = new ReqPlayerList({ start, limit })
            if (url === "") {
                toSearch({ searchItem: mReqPlayerList, page: url.page })
            } else {
                mReqPlayerList.fromJson(url)
                // console.log(mReqPlayerList)
                toSearch({ searchItem: mReqPlayerList, page: url.page })
            }
        }
    }, [id])

    function getTeamInfo(teams) {
        return <>
            {teams.map(team => {
                return <div><SingleLink link={'Team_Detail'} name={team.team_name} Key={'TeamEdit'} val={team}  ></SingleLink></div>
            })}
        </>
    }

    function getNumberInfo(teams){
        return <>
            {teams.map(team => {
                return <div>{team.player_number}</div>
            })}
        </>
    }

    useEffect(() => {
        var contents = []
        playerList.forEach(item => {
            var teams = JSON.parse(item.teams)
            var content = []
            content.push(setTD({ content: item._id }))
            content.push(setTDLink({ link: 'Player_Detail', content: item.player_name + " " + moment(item.player_DOB).format('YYYY'), key: 'PlayerEdit', val: item }))
            content.push(setTD({ content: getTeamInfo(teams) }))
            content.push(setTD({ content: getNumberInfo(teams) }))
            content.push(setTD({ content: get_player_position_string(item.player_position) }))
            content.push(setTD({ content: get_player_throw_bat_string(item.player_throw_bat) }))
            content.push(setTD({ content: get_activation_string(item.player_activation), color: get_activation_color(item.player_activation) }))
            contents.push(content)
        })
        // console.log(contents)
        var lb = {
            titles: [
                new TableListTitle('編號', 1),
                new TableListTitle('名字', 2),
                new TableListTitle('球隊', 2),
                new TableListTitle('背號', 1),
                new TableListTitle('守備', 2),
                new TableListTitle('投打', 2),
                new TableListTitle('狀態', 1),
            ],
            contents
        }

        set_list_obj(lb)

    }, [playerList])

    function toActionSearch(searchItems) {
        // console.log(searchItems)
        var mReqPlayerList = new ReqPlayerList({})
        searchItems.forEach((boxItem) => {
            if (Array.isArray(boxItem)) {
                boxItem.forEach(item => {
                    mReqPlayerList[item.key] = item.val
                })
            }
        })
        console.log("toActionSearch")
        console.log(mReqPlayerList)
        setSearchItems(searchItems)
        toSearch({ searchItem: mReqPlayerList })
    }

    function toSearch({ searchItem, page = 1 }) {
        // console.log("toSearch")
        // console.log(searchItem)
        var start = (page - 1) * limit;
        setPage(page)
        var mReqPlayerList = new ReqPlayerList({ start, limit })
        if (searchItem !== undefined){
            mReqPlayerList.fromJson(searchItem)
            mReqPlayerList.start = start
            mReqPlayerList.limit = limit
            // console.log("toSearch")
            // console.log(mReqPlayerList)
        }
        // setReqPlayerList(mReqPlayerList)
        set_searchItem(mReqPlayerList)
        setVal2Token("url", mReqPlayerList, id)
        getPlayerList(mReqPlayerList)
    }


    function getTeamList() {
        var mReqTeamList = new ReqTeamList({ 
            start:0, 
            limit:1000 
        })
        if (setIsLoading !== undefined)
            setIsLoading(true)
        // console.log(mReqTeamList)
        api_getTeamList({
            mReqTeamList,
            success: (obj) => {
                console.log(obj)
                set_team_attr(obj.list)
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }


    function getPlayerList(mReqPlayerList) {
        if (setIsLoading !== undefined)
            setIsLoading(true)
        // console.log(mReqPlayerList)
        api_getPlayerList({
            mReqPlayerList,
            success: (obj) => {
                console.log(obj)
                setPlayerList(obj.list)
                setCount(obj.count)
                setEnableCount(obj.enableCount)
                setDisableCount(obj.disableCount)
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    function toAdd() {
        window.location.assign("/Player_Add");
    }

    var baseTitle = "球員列表"
    var baseContent =
        <>
            <div className="row">
                <div className="col-sm-12">
                    <EnableBadge text={"啟用"} count={enableCount} />
                    <DisableBadge text={"停用"} count={disableCount} />
                    <AddButton name={"新增"} action={toAdd} />
                </div>
            </div>
            <Space />
            <ListBox row={7} lb={list_obj} lt={limit} srl={setPlayerList} count={count} page={page} sp={toSearch} searchItem={searchItem} />
        </>
    return (
        <>
            <BaseSearchBox action={toActionSearch} items={searchItems} />
            <ContentBox title={baseTitle} content={baseContent} hasDrawer={true} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}

